// Suno's current Style box character limit. Single source of truth for the cap, shared by
// the web editor, the browser-extension panel, and StyleField's default. The backend mirror
// lives in PromptImprover::STYLE_MAX_LENGTH (Ruby can't import this).
export const STYLE_MAX_LENGTH = 1000

// Where the "Add to Chrome" CTA (see <ExtensionCallout />) points. The extension isn't on
// the Chrome Web Store yet — it's load-unpacked (see extension/README.md). Swap this for the
// real listing URL once published.
export const CHROME_EXTENSION_URL = 'https://chrome.google.com/webstore'
